import React from "react";
import { Route, Switch } from 'react-router-dom';
import asyncComponent from "../../../itrust_common/components/AsyncComponent";

const SettingsWrapper = asyncComponent(() =>
  import('../../../containers/authorised/addOns/aiReceptionist/settings/SettingsWrapper')
)

const Dashboard = asyncComponent(() =>
  import('../../../containers/authorised/addOns/aiReceptionist/dashboard/DashboardWrapper')
)

const AiReceptionistRoutes = (
  <Switch>
    <Route exact path='/add-ons/ai-receptionist/settings' component={SettingsWrapper} />
    <Route exact path='/add-ons/ai-receptionist/dashboard' component={Dashboard} />
  </Switch>
)

export default AiReceptionistRoutes;